/**
 * AdminGate — guards admin routes.
 * Redirects to /login if unauthenticated, shows an error if the user is
 * authenticated but is not a platform admin.
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from './useAdminAuth';

export function AdminGate({ children }: { children: ReactNode }) {
  const { state } = useAdminAuth();

  if (state === 'loading') {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center">
        <p className="text-sm text-muted-foreground">Loading…</p>
      </div>
    );
  }

  if (state === 'unauthenticated') {
    return <Navigate to="/login" replace />;
  }

  if (state === 'not_admin') {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-xl font-semibold mb-2">Access denied</h1>
          <p className="text-sm text-muted-foreground">
            This area is restricted to platform administrators.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
